import {Col, Layout, Menu, message, Modal, Row, Space, Tabs} from "antd";
import {PersonNameGenerator} from "./PersonNameGenerator";
import {PlaceNameGenerator} from "./PlaceNameGenerator";
import {OtherNameGenerator} from "./OtherNameGenerator";
import {Translator} from "./Translator";
import React from "react";
import {TextGenerator} from "./TextGenerator";
import Sider from "antd/es/layout/Sider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAlignLeft,
    faBolt,
    faCompactDisc,
    faGear, faLanguage,
    faRotate, faStore, faTag,
    faUserLarge,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import {Content} from "antd/es/layout/layout";
import {BoltIcon} from "../../components/BoltIcons";

export const Tools = (props: { onClose: () => void }) => {
    const [category, setCategory] = React.useState('free_gen')

    return (
        <Layout style={{maxHeight: 800, overflow: 'hidden'}}>
            <Sider width={250}>
                <Menu
                    defaultSelectedKeys={['general']}
                    mode="inline"
                    style={{height: '100%', borderInlineEnd: '0'}}
                    items={[
                        {
                            key: 'free_gen',
                            label: <Space><BoltIcon secondary={faAlignLeft} size={16}/>Free text generator</Space>,
                        },
                        {
                            key: 'char_name_gen',
                            label:  <Space><BoltIcon secondary={faUserLarge} size={16}/>Character Name Generator</Space>,
                        },
                        {
                            key: 'place_name_gen',
                            label: <Space><BoltIcon secondary={faStore} size={16}/>Place Name Generator</Space>,
                        },
                        {
                            key: 'other_name_gen',
                            label: <Space><BoltIcon secondary={faTag} size={16}/>Other Name Generator</Space>,
                        },
                        {
                            key: 'translate',
                            label: <Space><BoltIcon secondary={faLanguage} size={16}/>Translator</Space>,
                        }
                    ]}
                    onClick={(item) => {
                        setCategory(item.key)
                    }}
                />
            </Sider>
            <Content style={{padding: '0 0 0 20px ', overflowY: 'auto', minWidth: 600, background: "#fff"}}>
                {category === 'free_gen' ? <TextGenerator onItemClick={(item) => {
                    navigator.clipboard.writeText(item)
                    message.info('Copied to clipboard');
                }}/> : ''}
                {category === 'char_name_gen' ? <PersonNameGenerator onItemClick={(item) => {
                    let text = ""
                    Object.keys(item).forEach((key, index) => {
                        text = text + item[key] + (index < Object.keys(item).length - 1 ? "\n" : '')
                    })
                    navigator.clipboard.writeText(text)
                    message.info('Copied to clipboard');
                }}/> : ''}
                {category === 'place_name_gen' ? <PlaceNameGenerator onItemClick={(item) => {
                    let text = ""
                    Object.keys(item).forEach((key, index) => {
                        text = text + item[key] + (index < Object.keys(item).length - 1 ? "\n" : '')
                    })
                    navigator.clipboard.writeText(text)
                    message.info('Copied to clipboard');
                }}/> : ''}
                {category === 'other_name_gen' ? <OtherNameGenerator onItemClick={(item) => {
                    let text = ""
                    Object.keys(item).forEach((key, index) => {
                        text = text + item[key] + (index < Object.keys(item).length - 1 ? "\n" : '')
                    })
                    navigator.clipboard.writeText(text)
                    message.info('Copied to clipboard');
                }}/> : ''}
                {category === 'translate' ? <Translator onItemClick={(item) => {
                    let text = ""
                    Object.keys(item).forEach((key, index) => {
                        text = text + item[key] + (index < Object.keys(item).length - 1 ? "\n" : '')
                    })
                    navigator.clipboard.writeText(text)
                    message.info('Copied to clipboard');
                }}/> : ''}
            </Content>
        </Layout>
    );
}